import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useIntersectionObserver } from '../../hooks';

interface FadeInProps {
    children: React.ReactNode;
    delay?: number;
    duration?: number;
}

const fadeInAnimation = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const AnimatedWrapper = styled.div<{ $isVisible: boolean; $delay: number; $duration: number }>`
    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    animation: ${({ $isVisible }) => ($isVisible ? fadeInAnimation : 'none')} 
        ${({ $duration }) => $duration}ms ease-out;
    animation-delay: ${({ $delay }) => $delay}ms;
    animation-fill-mode: both;
`;

export const FadeIn: React.FC<FadeInProps> = ({ 
    children, 
    delay = 200, 
    duration = 800 
}) => {
    const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1, triggerOnce: true });

    return (
        <AnimatedWrapper ref={ref} $isVisible={isVisible} $delay={delay} $duration={duration}>
            {children}
        </AnimatedWrapper>
    );
};
